import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import WelcomeScreen from './screens/WelcomeScreen';
import VocabularyScreen from './screens/VocabularyScreen';
import WritingScreen from './screens/WritingScreen';
import SpeakingSelectionScreen from './screens/SpeakingSelectionScreen';
import VocabularyListScreen from './screens/VocabularyListScreen';
import AboutUs from './screens/AboutUs';
import BookScreen from './screens/BookScreen';
import VocabScreen from './screens/VocabScreen';
import Flashcard from './screens/FlashCard';
import PrivacyPolicy from './screens/PrivacyPolicy';
import PlaySettingScreen from './screens/PlaySettingScreen';
import VocabularyTestScreen from './screens/VocabularyTestScreen';
import PlayVocabularyScreen from './screens/PlayVocabularyScreen';
import TestSettingScreen from './screens/TestSettingScreen';
import WriteVocabulary from './screens/WriteVocabulary';
import WriteVocabularySettings from './screens/WriteVocabularySettings';
import ChooseWriting from './screens/ChooseWriting';
import TestWriting from './screens/TestWriting';
import SpeakingScreen from './screens/SpeakingScreen';
import ContentScreen from './screens/ContentScreen';
import ProgressScreen from './screens/ProgressScreen';
import SettingsScreen from './screens/SettingsScreen';
import ContactScreen from './screens/ContactScreen';
import LearnedWordsScreen from './screens/LearnedWordsScreen';
import YkiGuidePage from './screens/YkiGuidePage';
import FaqPage from './screens/FaqPage';
import StudyTipsPage from './screens/StudyTipsPage';
import PageLayout from './components/PageLayout';
import { FailedQuestionsProvider } from './screens/FailedQuestionsContext';
import { AuthProvider } from './contexts/AuthContext';

const App = () => {
  return (
    <AuthProvider>
    <FailedQuestionsProvider>
    <Router>
      <PageLayout>
        <Routes>
          <Route path="/" element={<WelcomeScreen />} />
          <Route path="/vocabulary" element={<VocabularyScreen />} />
          <Route path="/writing" element={<WritingScreen />} />
          <Route path="/speaking" element={<SpeakingSelectionScreen />} />
          <Route path="/aboutus" element={<AboutUs />} />
          <Route path="/vocabularyList" element={<VocabularyListScreen />} />
          <Route path="/book-screen" element={<BookScreen />} />
          <Route path="/vocab-screen/:chapterNumber" element={<VocabScreen />} />
          <Route path="/flash-card" element={<Flashcard />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/test-setting-screen" element={<TestSettingScreen />} />
          <Route path="/play-setting-screen" element={<PlaySettingScreen />} />
          <Route path="/vocabulary-test-screen" element={<VocabularyTestScreen />} />
          <Route path="/play-vocabulary-screen" element={<PlayVocabularyScreen />} />
          <Route path="/write-vocabulary" element={<WriteVocabulary />} />
          <Route path="/write-vocabulary-settings" element={<WriteVocabularySettings />} />
          <Route path="/choose-writing" element={<ChooseWriting />} />
          <Route path="/test-writing" element={<TestWriting />} />
          <Route path="/speaking-screen" element={<SpeakingScreen />} />
          <Route path="/content-screen" element={<ContentScreen />} />
          <Route path="/progress" element={<ProgressScreen />} />
          <Route path="/settings" element={<SettingsScreen />} />
          <Route path="/contact" element={<ContactScreen />} />
          <Route path="/learned-words" element={<LearnedWordsScreen />} />
          <Route path="/yki-guide" element={<YkiGuidePage />} />
          <Route path="/faq" element={<FaqPage />} />
          <Route path="/study-tips" element={<StudyTipsPage />} />
        </Routes>
      </PageLayout>
    </Router>
    </FailedQuestionsProvider>
    </AuthProvider>
  );
};

export default App;
